module.exports = __webpack_public_path__ + "img/mandala_omnichannel.5974e058.png";